<p-button
  label="戻る"
  class="nav-button"
  styleClass="ui-button-secondary"
  icon="pi pi-arrow-left"
  iconPos="left"
  (click)="goBack()"></p-button>

<br />
<br />

<p-tabs value="0">
  <p-tablist>
    <p-tab value="0">プライスター</p-tab>
    <p-tab value="1">セドリスト</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <div style="margin-bottom: 8px">
        <input
          #pricetarFile
          type="file"
          accept=".csv,text/csv"
          style="display: none"
          (change)="onCsvSelected($event, 'pricetar')" />
        <p-button
          label="CSVファイルを選択"
          icon="pi pi-file-import"
          iconPos="left"
          (click)="pricetarFile.click()"></p-button>
        <span style="padding-left: 10px; color: #777; font-size: 0.85rem">
          プライスターのCSVをそのまま取り込めます（保留中の注文は自動で除外）。貼り付けでの取込も引き続き使えます。
        </span>
      </div>
      <textarea
        pInputTextarea
        [(ngModel)]="pricetar"
        style="width: 100%"></textarea>
      <p-button
        label="確認"
        styleClass="ui-button-primary"
        icon="pi pi-check-square"
        iconPos="left"
        (click)="doPricetarCheck()"
        [disabled]="!!!this.pricetar"></p-button>
      <span style="padding-left: 10px"></span>
      <p-button
        label="アップロード"
        styleClass="ui-button-success"
        icon="pi pi-upload"
        iconPos="left"
        (click)="doUploadPriceter()"
        [disabled]="!(this.pricetars && this.pricetars.length > 0)"></p-button>
    </p-tabpanel>

    <p-tabpanel value="1">
      <div class="grid">
        <div class="col-12">
          <p-radiobutton
            name="false"
            value="false"
            [(ngModel)]="isSedoristSearchList"
            inputId="false"></p-radiobutton>
          <label for="false">ウォッチリスト/仕入れリスト</label>
          <p-radiobutton
            name="true"
            value="true"
            [(ngModel)]="isSedoristSearchList"
            inputId="true"></p-radiobutton>
          <label for="true">検索リスト</label>
        </div>
      </div>

      <div style="margin-bottom: 8px">
        <input
          #sedoristFile
          type="file"
          accept=".csv,text/csv"
          style="display: none"
          (change)="onCsvSelected($event, 'sedorist')" />
        <p-button
          label="CSVファイルを選択"
          icon="pi pi-file-import"
          iconPos="left"
          (click)="sedoristFile.click()"></p-button>
        <span style="padding-left: 10px; color: #777; font-size: 0.85rem">
          せどりすとのCSVをそのまま取り込めます。貼り付けでの取込も引き続き使えます。
        </span>
      </div>
      <textarea
        pInputTextarea
        [(ngModel)]="sedorist"
        style="width: 100%"></textarea>
      <p-button
        label="確認"
        styleClass="ui-button-primary"
        icon="pi pi-check-square"
        iconPos="left"
        (click)="doSedoristCheck()"
        [disabled]="!!!this.sedorist"></p-button>
      <span style="padding-left: 10px"></span>
      <p-button
        label="アップロード"
        styleClass="ui-button-success"
        icon="pi pi-upload"
        iconPos="left"
        (click)="doUploadSedorist()"
        [disabled]="!(this.sedorists && this.sedorists.length > 0)"></p-button>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

@if (hasPriceter()) {
  <div>
    <div class="table-header-sticky-outer">
      全{{ pricetars.length.toLocaleString() }}件
      @if (pricetarSkipped > 0) {
        <span style="color: #c62828; padding-left: 10px">
          保留中（金額未確定）の注文 {{ pricetarSkipped }} 件を除外しました
        </span>
      }
      <p-table
        showGridlines
        [value]="pricetars"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [tableStyle]="{ width: '100%' }"
        class="share-table table-header-sticky p-datatable-gridlines p-datatable-wrap">
        <ng-template #header>
          <tr>
            <th style="width: 100px">ASIN</th>
            <th style="width: 100px">SKU</th>
            <th style="width: 300px">商品名</th>
            <th
              style="width: 100px"
              pSortableColumn="buyingPrice">
              仕入値
              <p-sorticon field="buyingPrice"></p-sorticon>
            </th>
            <th
              style="width: 100px"
              pSortableColumn="sellingPrice">
              売価
              <p-sorticon field="sellingPrice"></p-sorticon>
            </th>
            <th
              style="width: 100px"
              pSortableColumn="costPrice">
              手数料
              <p-sorticon field="costPrice"></p-sorticon>
            </th>
            <th style="width: 100px">配送経路</th>
            <th style="width: 80px">状態</th>
            <th
              style="width: 120px"
              pSortableColumn="orderDate">
              注文日
              <p-sorticon field="orderDate"></p-sorticon>
            </th>
          </tr>
        </ng-template>
        <ng-template
          #body
          let-priceter>
          <tr>
            <td>{{ priceter.asin }}</td>
            <td>{{ priceter.sku }}</td>
            <td>{{ priceter.name }}</td>
            <td>{{ priceter.buyingPrice.toLocaleString() }}</td>
            <td>{{ priceter.sellingPrice.toLocaleString() }}</td>
            <td>{{ priceter.costPrice.toLocaleString() }}</td>
            <td>{{ priceter.deliveryRoute }}</td>
            <td>{{ priceter.condition }}</td>
            <td>{{ priceter.orderDate | japanDate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}

@if (hasSedorist()) {
  <div>
    <div class="table-header-sticky-outer">
      全{{ sedorists.length.toLocaleString() }}件
      <p-table
        showGridlines
        [value]="sedorists"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [tableStyle]="{ width: '100%' }"
        class="share-table table-header-sticky p-datatable-gridlines p-datatable-wrap">
        <ng-template #header>
          <tr>
            <th style="width: 100px">ASIN</th>
            <th style="width: 100px">JAN</th>
            <th style="width: 100px">SKU</th>
            <th style="width: 300px">商品名</th>
            <th
              style="width: 100px"
              pSortableColumn="buyingPrice">
              仕入値
              <p-sorticon field="buyingPrice"></p-sorticon>
            </th>
            <th
              style="width: 120px"
              pSortableColumn="sellingPrice">
              出品予定価格
              <p-sorticon field="sellingPrice"></p-sorticon>
            </th>
            <th style="width: 80px">状態</th>
            <th style="width: 100px">配送経路</th>
            <th
              style="width: 120px"
              pSortableColumn="buyingDate">
              仕入日
              <p-sorticon field="buyingDate"></p-sorticon>
            </th>
          </tr>
        </ng-template>
        <ng-template
          #body
          let-sedorist>
          <tr>
            <td>{{ sedorist.asin }}</td>
            <td>{{ sedorist.jan }}</td>
            <td>{{ sedorist.sku }}</td>
            <td>{{ sedorist.name }}</td>
            <td>{{ sedorist.buyingPrice.toLocaleString() }}</td>
            <td>{{ sedorist.sellingPrice.toLocaleString() }}</td>
            <td>{{ sedorist.condition }}</td>
            <td>{{ sedorist.deliveryRoute }}</td>
            <td>{{ sedorist.buyingDate | japanDate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
